import React from 'react';
import get from 'lodash/get';

import { ReactComponent as Dashboard } from 'Images/manage.svg';
import { ReactComponent as Automation } from 'Images/automation.svg';
import { ReactComponent as Planner } from 'Images/tasks_icon.svg';
import { ReactComponent as Reports } from 'Images/reports.svg';
import { ReactComponent as Analytics } from 'Images/analytics.svg';
import { ReactComponent as Users } from 'Images/icon_users.svg';
import { ReactComponent as KnowledgeBase } from 'Images/vuln-kb.svg';
import { ReactComponent as MCP } from 'Images/mcp_icon.svg';

import FFAnalytics from 'Images/ff_analytics.png';
import FFPlanner from 'Images/ff_planner.png';
import FFReports from 'Images/ff_reporting.png';
import FFUsers from 'Images/ff_users.png';

export const selectIsOpen = (state) => get(state, 'sideBar.isOpen', false);
export const selectPagesData = (state) => {
  return [
    {
      name: 'Management',
      icon: <Dashboard />,
      subMenu: [
        {
          name: 'Management',
          url: '/workspaces',
          enabledByRole: true,
          enabledByFeature: true,
          subPaths: ['/workspaces', '/manage', '/feed', '/hosts', '/host', '/services', '/service', '/vulnerabilities', '/credentials']
        }
      ]
    },
    {
      name: 'Knowledge Base',
      icon: <KnowledgeBase />,
      subMenu: [
        {
          name: 'Knowledge Base',
          url: '/knowledge_base',
          enabledByRole: true,
          enabledByFeature: true,
          subPaths: ['/knowledge_base']
        }
      ]
    },
    {
      name: 'Analytics',
      icon: <Analytics />,
      subMenu: [
        {
          name: 'Analytics',
          url: null,
          enabledByRole: true,
          enabledByFeature: false,
          FF: {
            image: FFAnalytics,
            description: 'upgradeLicense.sidebar.analytics.description'
          }
        }
      ]
    },
    {
      name: 'Planner',
      icon: <Planner />,
      subMenu: [
        {
          name: 'Planner',
          url: null,
          enabledByRole: true,
          enabledByFeature: false,
          FF: {
            image: FFPlanner,
            description: 'upgradeLicense.sidebar.planner.description'
          }
        }
      ]
    },
    {
      name: 'Reports',
      icon: <Reports />,
      subMenu: [
        {
          name: 'Reports',
          url: null,
          enabledByRole: true,
          enabledByFeature: false,
          FF: {
            image: FFReports,
            description: 'upgradeLicense.sidebar.reporting.description'
          }
        }
      ]
    },
    {
      name: 'Automation',
      icon: <Automation />,
      subMenu: [
        {
          name: 'Runners & Security Scanners',
          url: '/automation/agents',
          enabledByRole: true,
          enabledByFeature: true
        },
        {
          name: 'Scheduler',
          url: '/automation/schedule',
          enabledByRole: true,
          enabledByFeature: true
        },
        {
          name: 'Pipelines',
          url: '/automation/pipelines',
          enabledByRole: true,
          enabledByFeature: true,
          subPaths: ['/automation/pipelines']
        },
        {
          name: 'Jobs',
          url: '/automation/jobs',
          enabledByRole: true,
          enabledByFeature: true,
          subPaths: ['/automation/jobs']
        }
      ]
    },
    {
      name: 'Users',
      icon: <Users />,
      subMenu: [
        {
          name: 'Users',
          url: null,
          enabledByRole: true,
          enabledByFeature: false,
          FF: {
            image: FFUsers,
            description: 'upgradeLicense.sidebar.users.description'
          }
        }
      ]
    },
    {
      name: 'Faraday MCP',
      icon: <MCP />,
      subMenu: [
        {
          name: 'Faraday MCP',
          url: '/mcp',
          enabledByRole: true,
          enabledByFeature: true
        }
      ]
    }
  ];
};
